import React, { ReactNode } from 'react';
import styled from 'styled-components';

type Props = {
    lang?: string;
    loading?: boolean;
    children?: ReactNode;
};

const StylishLoading = (props: Props) => {
    const label = props.lang ? (props.lang === 'en' ? 'Loading' : '読み込み中') : '読み込み中';
    const className = props.loading ? 'loading' : 'loading loading--loaded';
    return (
        <WrapperWithStyled>
            {props.children}
            <LoadingWrapperWithStyled className={className}>
                <LoadingWithStyled>
                    <LoadingLabelWithStyled>
                        {label}
                        <LoadingAnime1WithStyled>.</LoadingAnime1WithStyled>
                        <LoadingAnime2WithStyled>.</LoadingAnime2WithStyled>
                        <LoadingAnime3WithStyled>.</LoadingAnime3WithStyled>
                    </LoadingLabelWithStyled>
                </LoadingWithStyled>
            </LoadingWrapperWithStyled>
        </WrapperWithStyled>
    );
};

const WrapperWithStyled = styled.div`
    position: relative;
    min-height: 20px;
`
const LoadingWrapperWithStyled = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, .8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;
    top: 0;
`
const LoadingWithStyled = styled.div`
    posision: relative;
`
const LoadingLabelWithStyled = styled.span`
    font-weight: bold;
`
const LoadingAnime1WithStyled = styled.span`
    margin: 0 0 0 2px;
    animation-name: animation-loading;
    animation-duration: 1s;
    animation-iteration-count: infinite;
    animation-delay: .1s;
`
const LoadingAnime2WithStyled = styled.span`
    margin: 0 0 0 1px;
    animation-name: animation-loading;
    animation-duration: 1s;
    animation-iteration-count: infinite;
    animation-delay: .2s;
`
const LoadingAnime3WithStyled = styled.span`
    margin: 0 0 0 1px;
    animation-name: animation-loading;
    animation-duration: 1s;
    animation-iteration-count: infinite;
    animation-delay: .3s;
`
export default StylishLoading;